import styled, { css } from "styled-components";
import getBoxShadow from "../../../../utils/getBoxShadow";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import ButtonAtm from "../../../atoms/ButtonAtm";
import FlexContainerOrg from "../../../organisms/FlexContainerOrg";
import { backgroundColor, paddingSpace } from "../AdvancedProductCardMol.settings";
import { parametersPushSpaceOnMobile } from "./Footer.settings";
export var FooterContainer = styled(FlexContainerOrg).withConfig({
  componentId: "sc-rxgo02-0"
})(["flex:1;"]);
export var PaymentContainer = styled.div.withConfig({
  componentId: "sc-rxgo02-1"
})(function (_ref) {
  var $isMobileDetailsView = _ref.$isMobileDetailsView,
    $isFloating = _ref.$isFloating,
    theme = _ref.theme;
  return $isMobileDetailsView && css(["position:fixed;right:0;bottom:0;left:0;padding:", " ", " ", ";background:", ";", ""], space(parametersPushSpaceOnMobile), space(paddingSpace), space(paddingSpace), getColor(theme, backgroundColor), $isFloating && css(["box-shadow:", ";"], getBoxShadow(theme, "small", true)));
});
export var PriceContainer = styled.div.withConfig({
  componentId: "sc-rxgo02-2"
})(function (_ref2) {
  var $minHeight = _ref2.$minHeight;
  return $minHeight ? css(["min-height:", ";"], unit($minHeight)) : null;
});
export var StyledButtonAtm = styled(ButtonAtm).withConfig({
  componentId: "sc-rxgo02-3"
})(["position:relative;z-index:1;"]);